export default `
	guid
	app_version
	build_version
	onboarding_shown
`;
